import { useRouter } from 'next/router'
// discover new dashboards
import React, { ReactElement } from 'react'

import { Box, HStack, Text, VStack } from '@chakra-ui/react'

import { goToProfile } from '../../utils/general/goToProfile'
import DefaultAvatar from '../general/DefaultAvatar'
import { UserSearchResult as UserSearchResultType } from './types'

interface Props {
  result: UserSearchResultType
}
const UserSearchResult = ({ result }: Props): ReactElement => {
  const { data } = result
  const router = useRouter()

  // TODO: supplement data with avatar & bio from firebase if not in elastic

  return (
    <Box w="100%" p={4} my={3}>
      <HStack spacing={3}>
        <DefaultAvatar
          user={data}
          size={'md'}
          onClick={() => {
            goToProfile(router, data.username)
          }}
        />
        <VStack align="start" spacing={0}>
          <HStack>
            <Text
              fontWeight={'semibold'}
              as="a"
              href={`/${data.username}`}
              _hover={{
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              {data.displayName}
            </Text>
            {/* <Text
              color="brand.username"
              href={`/${data.username}`}
              _hover={{
                // textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              @{data.username}
            </Text> */}
          </HStack>
          <Text>{data.bio}</Text>
        </VStack>
      </HStack>
    </Box>
  )
}

export default UserSearchResult
